import { Field, Form, Formik } from 'formik';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CircularProgress } from '@material-ui/core';
import FormTextField from '../../common/form/FormTextField';
import CommonButton from '../../common/CommonButton';
import withStyles from '@material-ui/core/styles/withStyles';
import { BLACK_COLOR, BORDER_DARK_TEXT } from '../../../const/color-const';
import PropTypes from 'prop-types';
import CommonDivider from '../../common/CommonDivider';
import CommonSelectField from '../../common/form/CommonSelectField';

const INPUT_HEIGHT = 52;
const WRAPPER_WIDTH = 260;
const [INPUT_WIDTH_DESKTOP, INPUT_WIDTH_MOBILE] = [200, 238];
const BUTTON_WIDTH = 180;

const styles = theme => ({
  form: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  formContent: {
    display: 'flex',
    flexWrap: 'wrap',
    textAlign: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
    },
    '& [class*="commonSelectField"]': {
      marginTop: theme.spacing(1),
      width: INPUT_WIDTH_MOBILE,
      [theme.breakpoints.up('sm')]: {
        width: INPUT_WIDTH_DESKTOP,
        marginTop: 'unset',
      },
      '& > div': {
        background: theme.palette.type === 'light' ? 'white' : BLACK_COLOR,
      },
      '& label': {
        top: 2,
        marginLeft: 'unset',
      },
    },
    '& div': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: INPUT_HEIGHT,
      maxWidth: WRAPPER_WIDTH,
      margin: theme.spacing(0.5, 0, 0.5, 0),
      [theme.breakpoints.up('sm')]: {
        margin: theme.spacing(0, 1, 0, 1),
      },
      '& input': {
        border: theme.palette.type === 'light' ? '1px solid Silver' : `1px solid ${BORDER_DARK_TEXT}`,
        padding: theme.spacing(0, 0, 0, 1),
        height: INPUT_HEIGHT,
        borderRadius: 4,
      },
      '& label': {
        marginLeft: 10,
        top: -5,
      },
      '&:before, &:after': {
        display: 'none',
      },
    },
    '& [class*="MuiTextField"]': {
      minWidth: 'unset',
      width: INPUT_WIDTH_MOBILE,
      marginTop: theme.spacing(1),
      background: theme.palette.type === 'light' ? 'white' : BLACK_COLOR,
      '& label[class*="Mui-focused"], label[class*="MuiFormLabel-filled"]': {
        top: 2,
      },
      [theme.breakpoints.up('sm')]: {
        width: INPUT_WIDTH_DESKTOP,
        marginTop: 'unset',
      },
    },
    '& button': {
      [theme.breakpoints.down('md')]: {
        height: INPUT_HEIGHT,
        width: BUTTON_WIDTH,
      },
    },
  },
  circularProgress: {
    marginTop: theme.spacing(2),
  },
});

const AdministrationPageForm = React.forwardRef((props, ref) => {
  const { classes, handleSubmit, cashRegisterSelect } = props;
  
  const SEARCH_OPTIONS = [{ value: 'searchText', label: 'Default' }];
  
  return (
    <Formik
      innerRef={ref}
      initialValues={{ search: 'searchText' }}
      onSubmit={handleSubmit}>
      {({ isSubmitting, values }) => {
        return (
          <Form className={classes.form}>
            <div className={classes.formContent}>
              {cashRegisterSelect}
              <Field
                name="search"
                component={CommonSelectField}
                label={
                  <FormattedMessage
                    id="search"
                    defaultMessage="Search"
                  />}
                options={SEARCH_OPTIONS}
                disabled={isSubmitting}
              />
              
              <Field
                variant="standard"
                name="text"
                component={FormTextField}
                label={
                  <FormattedMessage
                    id="field.free.text"
                    defaultMessage="Text"
                  />}
              />
              
              <CommonButton
                isAnimated
                searchButton
                size="large"
                type="submit"
                label={<>
                  <FormattedMessage
                    id="search"
                    defaultMessage="Search"
                  />
                </>}
                disabled={isSubmitting}
              />
            </div>
            {isSubmitting && <CircularProgress className={classes.circularProgress} />}
            <CommonDivider />
          </Form>
        );
      }}
    </Formik>
  );
});

AdministrationPageForm.propTypes = {
  classes: PropTypes.object,
  handleSubmit: PropTypes.func,
  cashRegisterSelect: PropTypes.object,
};

export default withStyles(styles)(AdministrationPageForm);
